module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6Ar5Zp/images/frontcover.jpg?1685790699126",
      "alt": "This image is the cover for the book Then and Now"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Then and Now\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("One of the best first-person accounts of 19th-century frontier life in Montana. First published in 1900, Vaughan's account is a series of letters to his daughter. Contemporary historian Dave Walter adds a new introduction that sets the scene and fills in what readers need to know to appreciate Vaughan's experiences.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robert Vaughn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Robert Vaughn is the quintessential Montana pioneer. By his own definition, he had arrived in Montana Territory in the 1860s, worked hard, took risks, involved himself in civic affairs, and prospered. Most important, he had remained on the Montana scene--long enough for his stories of \"the early days\" to hold credence. The energetic Robert built a solid ranching operation near the present-day town of Vaughn, Montana, his namesake, west of Great Falls. During the 1870s and 1880s the ranch sat relatively close to the Blackfeet reservation, and Vaughn experienced repeated encounters with local Indians and with other bands moving through the area. By the turn of the century, Robert Vaughn's personal kindness and honest public dealings had gained him widespread in Montana.Great Falls residents called him \"Uncle Bob.\" (from the Introduction, by Dave Walter.)")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Farcountry Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0